import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from '../../components/TemplateDashboard';
import AlertNotificaciones from '../../components/AlertNotificaciones/AlertNotificaciones';
import ExposicionesOralesContent from './components/ExposicionesOralesContent';

const ExposicionesOrales = () => {

    return (
        <>

            <TemplateDashboard>
                <AlertNotificaciones />
                <ExposicionesOralesContent />
            </TemplateDashboard>

        </>
    )
};

export default ExposicionesOrales;